// 生产UUID字符串
export const createUuid = () => {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		const r = (Math.random() * 16) | 0,
			v = c == "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

// 将uuid转换为数字
export function uuidToNumber(uuid: string) {
	const hexDigits = uuid.replace(/-/g, "");
	const hexArray = hexDigits.split("");
	const numArray = hexArray.map((hexDigit) => parseInt(hexDigit, 16));
	const num = numArray.reduce((acc, num) => (acc << 4) + num);
	return num;
}
